import React, { useEffect, useRef, useState } from 'react';
import './BackgroundShapes.css';

// 随机选择一个图形
const getRandomShape = () => {
  const shapes = ['circle', 'triangle', 'hexagon'];
  return shapes[Math.floor(Math.random() * shapes.length)];
};

// 随机生成一个不与已有图形重叠的位置
const getRandomPosition = (size, existingShapes) => {
  let x, y;
  let isOverlapping = true;

  // 随机生成不重叠的位置
  while (isOverlapping) {
    x = Math.random() * (window.innerWidth - size);
    y = Math.random() * (window.innerHeight - size);

    isOverlapping = existingShapes.some((shape) => {
      const distance = Math.sqrt(
        Math.pow(x - shape.x, 2) + Math.pow(y - shape.y, 2)
      );
      return distance < shape.size + size;
    });
  }

  return { x, y };
};

const BackgroundShapes = () => {
  const containerRef = useRef(null);
  const [shapes, setShapes] = useState([]);

  // 生成图形的方法
  const generateShapes = () => {
    const newShapes = [];
    const numShapes = 130; // 随机生成的图形数量

    for (let i = 0; i < numShapes; i++) {
      const shapeType = getRandomShape(); // 随机选择图形
      const size = Math.random() * 60 + 20; // 随机大小
      const { x, y } = getRandomPosition(size, newShapes); // 随机生成位置，避免重叠
      const rotation = Math.random() * 360; // 随机角度（0 - 360）

      newShapes.push({
        shapeType, // 使用已选择的图形类型
        size,
        x,
        y,
        rotation,
      });
    }

    return newShapes;
  };

  // 处理鼠标移动事件，调整图形大小
  const handleMouseMove = (e) => {
    const { clientX: mouseX, clientY: mouseY } = e;
    const shapesElements = containerRef.current.querySelectorAll('.background-shape');

    shapesElements.forEach((shape) => {
      const rect = shape.getBoundingClientRect();
      const shapeX = rect.left + rect.width / 2;
      const shapeY = rect.top + rect.height / 2;
      const distance = Math.sqrt(Math.pow(mouseX - shapeX, 2) + Math.pow(mouseY - shapeY, 2));

      // 根据距离调整图形的大小
      const scaleFactor = Math.max(1 - distance / 1200, 0.6); // 距离越远，变小的程度越弱

      // 获取原本的旋转角度，确保不被覆盖
      const originalTransform = shape.style.transform;
      const rotateValue = originalTransform.match(/rotate\((-?\d+(\.\d+)?)deg\)/);
      const rotateAngle = rotateValue ? rotateValue[1] : 0; // 如果存在旋转，提取旋转角度

      // 组合缩放和旋转效果
      shape.style.transform = `scale(${scaleFactor}) rotate(${rotateAngle}deg)`;
    });
  };

  // 初始化生成图形并监听鼠标事件
  useEffect(() => {
    const newShapes = generateShapes();
    setShapes(newShapes);

    // 监听鼠标移动事件
    document.addEventListener('mousemove', handleMouseMove);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <div className="background-shapes" ref={containerRef}>
      {shapes.map((shape, index) => (
        <div
          key={index}
          className={`background-shape ${shape.shapeType}`}
          style={{
            width: shape.size + 'px',
            height: shape.size + 'px',
            left: shape.x + 'px',
            top: shape.y + 'px',
            transform: `rotate(${shape.rotation}deg)`, // 添加旋转角度
          }}
        />
      ))}
    </div>
  );
};

export default BackgroundShapes;
